<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="mat-form-field-templateId">
            <mat-label>Modèle de mail</mat-label>
            <mat-select data-select-templateId formControlName="templateId" tabindex="10">
                @for (item of _templates; track item.id) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['templateId'].required && (dataForm.controls['templateId']?.dirty || dataForm.controls['templateId'].touched)) {
                <mat-error data-input-role-error>Le champ 'Modèle de mail' est obligatoire</mat-error>
            }
        </mat-form-field>
    </div>
</form>
